module.exports = require("/home/travis/build/lyft/lyft.github.io/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 357
// module chunks = 231608221292675